module.exports = __webpack_public_path__ + "static/media/icon_search.a4e4f4b5.svg";